export interface Module {
  _id: string
  name: string
  key: string
  description: unknown[]
}

export interface Section {
  title: string
  modules: Module[]
}

export enum EventStatus {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
  INACTIVE = 'INACTIVE',
  DIALOGUE = 'DIALOGUE',
  TROPHY_DIALOGUE = 'TROPHY_DIALOGUE',
  INIT = 'INIT',
}

export type EventData = EventInfo & {
  id: string
  eventFeature?: REWARD_FEATURE
  eventType?: string
}

export enum EventType {
  QUEST = 'quest',
  PET = 'pet',
  CHAMPIONSHIP = 'championship',
}

export type Dialogue = Array<{ title: string; text: string }>

export interface EventInfo {
  award?: Award
  dialogue?: Dialogue
  funfact?: string
  mathEnergyOrbs?: number
  nextQuest?: string
  // parentEventId?: string
  petName?: string
  points?: number
  stars?: number
  status?: EventStatus
  stepsCompleted?: number
  threshold?: number
  title?: string
  type?: EventType
}

interface SuccessResponse {
  success: boolean
}
export type EventResponse = SuccessResponse
export type PetStateResponse = SuccessResponse

export interface AvatarResponse {
  data: {
    avatarUrl: string
    avatarPngUrl: string
  }
}

export enum GameEventId {
  INTRO = 'INTRO',
  POINTS = 'POINTS',
  QUIZ = 'QUIZ',
  QUIZ_CHEST = 'QUIZ_CHEST',
  WELCOME = 'WELCOME',
  MULT_GAME = 'MULT_GAME',
  ADVANCED_TOPIC_QUIZ = 'ADVANCED_TOPIC_QUIZ',
}

export enum Award {
  STANDARD = 'STANDARD',
  FIRST = 'FIRST',
  SECOND = 'SECOND',
  THIRD = 'THIRD',
}

export enum REWARD_FEATURE {
  BOOTCAMP = 'bootcamp',
  CHAMPIONSHIP = 'championship',
  ENCYCLOPEDIA = 'encyclopedia',
  GAME_MULTGAME = 'game-multgame',
  GAME_STACKN_LOAD = 'game-stack-n-load',
  GAME_TREASURE_TRAIL = 'game-treasure-trail',
  GAME_WIND_SURFER = 'game-wind-surfer',
  MATH_ESSENTIALS = 'math-essentials',
  MATH_VAULT = 'math-vault',
  ONBOARDING = 'onboarding',
  PET = 'pet',
  QUEST = 'quest',
  SHOP = 'shop',
  SYSTEM = 'system',
  UNSPECIFIED = 'unspecified',
  CHECKLIST = 'checklist',
  CREATE_AVATAR = 'createAvatar',
  EXPLORE_SPACE = 'exploreSpace',
  MATH_TASK = 'mathTask',
  EXPLORE_LEADERBOARD = 'exploreLeaderboard',
  VERIFY_EMAIL = 'verifyEmail',
  PICK_CURRICULUM = 'pickCurriculum',
  WATCH_VIDEO = 'watchVideo',
  COMPLETE_CURRICULUM_ACTIVITY = 'completeCurriculumActivity',
  COMPLETE_PROFILE = 'completeProfile',
  COMPLETED_CHECKLIST = 'completedCheckList',
  CURRICULUM = 'curriculum',
  REFERRAL = 'referral',
  TEST_GENERATOR = 'testGenerator',
}

export enum REWARD_EVENT {
  ROUND_CREATED = 'round_create',
  DEFAULT = 'default_reward',
  GAME_ENDED = 'game-ended',
  REWARDS = 'rewards',
  ANSWERED = 'answered',
  CHECKMARK = 'checkmark',
  FEED_DRAGON = 'feed_dragon',
  COLLECT_GEMS = 'collect_gems',
  RECEIVE_KUDOS = 'receive_kudos',
}

export interface GamificationRewards {
  gems: number
  xp: number
  kudos: number
  lifetimeGems: number
  lifetimeKudos: number
  userId: number
}
export interface GamificationRewardsRequest {
  gems?: number
  xp?: number
  kudos?: number
  feature: REWARD_FEATURE
  event_id: string
}
